"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleCheck, FileSearch, Target } from "lucide-react";
export default function ProcessSteps() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const steps = [{
    icon: FileSearch,
    title: "Diagnostic Evaluation",
    description: "We assess your practice across five core pillars to identify where growth is being constrained.",
    ref: ref1,
    isVisible: isVisible1,
    delay: "0ms"
  }, {
    icon: Target,
    title: "Constraint Identification",
    description: "We pinpoint the single primary obstacle preventing your practice from scaling efficiently.",
    ref: ref2,
    isVisible: isVisible2,
    delay: "100ms"
  }, {
    icon: CircleCheck,
    title: "Prescriptive Next Step",
    description: "You receive a clear, actionable prescription for what must be fixed next—no guessing required.",
    ref: ref3,
    isVisible: isVisible3,
    delay: "200ms"
  }];
  return <section id="process-steps" className="bg-background py-24">
      <div className="mx-auto max-w-3xl px-6">
        <div className="flex flex-col gap-12">
          {steps.map((step, i) => {
          const IconComponent = step.icon;
          return <div key={i} data-index={i} ref={step.ref} className="flex flex-col gap-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
            opacity: step.isVisible ? 1 : 0,
            transform: step.isVisible ? "translateY(0)" : "translateY(1rem)",
            transitionDelay: step.isVisible ? step.delay : "0ms"
          }}>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.04]">
                    <IconComponent className="h-12 w-12 text-primary" strokeWidth={1.5} />
                  </div>
                  <div className="flex flex-col gap-2">
                    <h3 className="font-display font-semibold text-foreground !text-3xl">
                      {step.title}
                    </h3>
                    <p className="font-sans leading-relaxed text-muted-foreground !text-xl">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}